import React from "react";
import { Button, Grid, Checkbox } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
// import Switch from "@mui/material/Switch";
import VerifiedIcon from "@mui/icons-material/Verified";
// import avtarPic from "../../../assets/Images/avtarPic.png";
import moment from "moment";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
// import SafetyCheckIcon from "@mui/icons-material/SafetyCheck";
import GppBadIcon from "@mui/icons-material/GppBad";
import UpdateIcon from "@mui/icons-material/Update";
import IconButton from "@mui/material/IconButton";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import FormGroup from "@mui/material/FormGroup";
// End

import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

import swal from "sweetalert";

import { makePostRequest } from "../../../utils/utils";
import Pagination from "@mui/material/Pagination";
import QRCode from "react-qr-code";

const label = { inputProps: { "aria-label": "Size switch demo" } };

// For Modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import CloseIcon from "@mui/icons-material/Close";
// End

function AllServiceProvidersNewList() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  async function handleChangeSortBy(event) {
    // setAnchorEl(event.currentTarget);
    if (sortBy === "") setSortBy("ASC");
    else if (sortBy === "DESC") setSortBy("ASC");
    else if (sortBy === "ASC") setSortBy("DESC");
    setUpload(!Upload);
    alert(sortBy);
    ServiceProviderListing();
  }

  async function handleClose(selectedStatus) {
    setShowLoader(true);
    setStatus(selectedStatus);
    setUpload(!Upload);
    await ServiceProviderListing();
    setAnchorEl(null);
    setShowLoader(false);
  }
  // End

  // For Modal
  const [open2, setOpen] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const [selectedName, setSelectedName] = React.useState("");
  const [selectedContactNo, setSelectedContactNo] = React.useState("");
  const [selectedServiceType, setSelectedServiceType] = React.useState("");
  const [selectedProfilePic, setSelectedProfilePic] = React.useState("");
  const [selectedCommitteMem, setSelectedCommiteeMem] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = React.useState("");
  const [, setApprovedByCommiteeMem] = React.useState("");
  const [providerId, setproviderId] = React.useState();
  
  // const [selectedCommitteMem, setSelectedCommiteeMem] = React.useState([]);
  const handleClickOpen2 = (scrollType, selectedObj) => () => {
    // alert(selectedObj.firstname);
    setSelectedName(selectedObj.firstname + " " + selectedObj.lastname);
    setSelectedContactNo(selectedObj.contact_no);
    setSelectedProfilePic(selectedObj.profile_pic);
    setSelectedServiceType(selectedObj.service_type);
    setSelectedStatus(selectedObj.status);
    setproviderId(selectedObj.service_provider_id)
    setOpen(true);
    setScroll(scrollType);
  };
  const handleClose2 = () => {
    setOpen(false);
  };

  const handleClickOpen4 =
    (scrollType, id, commiteeMemIdList, approvedByCommiteeMem, status) =>
    () => {
      setShowLoader(true);
      setServiceProviderId(id);
      // alert(commiteeMemIdList)
      if (commiteeMemIdList) {
        setSelectedCommiteeMem(commiteeMemIdList.splice(","));
      }
      if (approvedByCommiteeMem) {
        setApprovedByCommiteeMem(approvedByCommiteeMem.splice(","));
      }
      setSelectedStatus(status);
      commiteeMemberlisting();
      setUpload(!Upload);
      setOpen4(true);
      setScroll(scrollType);
      setShowLoader(false);
    };
  const handleClose4 = () => {
    setSelectedCommiteeMem([]);
    setOpen4(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [selected, setSelected] = React.useState(false);

  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  const [serviceProviderList, setServiceProviderList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [, setlength] = React.useState();
  const [showLoader, setShowLoader] = React.useState(false);
  const [serviceProviderId, setServiceProviderId] = React.useState();
  // const [isActive, setIsActive] = React.useState();
  const [sortBy, setSortBy] = React.useState("");
  const [commiteeMemlist, setCommiteeMemlist] = React.useState([]);
  const [sendToCommiteeMemList] = React.useState([]);
  const [isApprovedByAdmin, setIsApprovedByAdmin] = React.useState(true);
  const [Upload, setUpload] = React.useState(true);

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };
  async function ServiceProviderListing() {
    setShowLoader(true);
    let bodyFormData = {
      searchq: q,
      status: status,
      sortBy: sortBy,
      pageNo: currentPage,
      count: itemsPerPage,
    };

    await makePostRequest("serviceProvider/listing", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("sdervice Provider Data");
          console.log(response.data.data);
          setlength(response.data.data.rowCount);
          const data = response.data.data.data;
          setServiceProviderList(data);
          setTotalItems(response.data.data.total_records);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  }

  async function commiteeMemberlisting() {
    let bodyFormData = {
      searchq: "",
      pageNo: "",
      count: "",
    };
    setShowLoader(true);
    await makePostRequest("resident/commiteememlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data.data);
          // const data = response.data.data.rows;
          setCommiteeMemlist(response.data.data.data);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(errMsg, "", "warning");
        setShowLoader(false);
      });
  }

  async function handleChangeCheckbox(e, commiteeMemId) {
    //to add selected commitee mem in array

    if (e.target.checked) selectedCommitteMem.push(commiteeMemId);
    //to remove unchecked commitee mem from array
    else selectedCommitteMem.splice(selectedCommitteMem.indexOf(commiteeMemId));

    setSelectedCommiteeMem(selectedCommitteMem);

    // setSendToCommiteeMemList(sendToCommiteeMemList);

    console.log("Mem List " + sendToCommiteeMemList);
  }

  async function sendToCommiteeMemApproval() {
    let bodyFormData = {
      service_provider_id: serviceProviderId,
      is_approved_by_admin: isApprovedByAdmin,
      send_to_commitee_mem: selectedCommitteMem,
    };
    setShowLoader(true);
    await makePostRequest("serviceProvider/update", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          swal("Success", "Approval sent successfully", "success", {
            timer: 3000,
            buttons: false,
          });
          handleClose4();
          window.location.reload();
          // ServiceProviderListing();
          //navigate("/AllServiceProviders");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(errMsg, "", "warning");
        setShowLoader(false);
      });
  }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    localStorage.removeItem("apartmentIdList");

    ServiceProviderListing();
  }, [open2, q, Upload, currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorListNewInner visitorListNewInnerMain">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={(e) => setQ(e.target.value)}
                    />
                    {/* <MicIcon className="visitorMicIco" /> */}
                  </div>
                  <div className="sortingIcoOut">
                    <ToggleButton
                      value="check"
                      selected={selected}
                      onChange={() => {
                        setSelected(!selected);
                      }}
                    >
                      <ImportExportIcon
                        className="visitorFilterIco"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={(e) => handleChangeSortBy(e)}
                      />
                    </ToggleButton>
                  </div>
                  <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => handleClose("")}>All</MenuItem>
                    <MenuItem onClick={() => handleClose("pending")}>
                      Pending
                    </MenuItem>
                    <MenuItem onClick={() => handleClose("approved")}>
                      Active
                    </MenuItem>
                    <MenuItem onClick={() => handleClose("rejected")}>
                      Rejected
                    </MenuItem>
                  </Menu>
                </div>
                {serviceProviderList.map((option) => (
                  <div className="visitContDiv">
                    <div className="visitCont1 resideNewContOut">
                      <div className="servProviderStatus">
                        {option.status == "pending" &&
                        option.send_to_commitee_mem ? (
                          <Button className="sendApproBt showStatus">
                            {" "}
                            Sent For Approval
                          </Button>
                        ) : (
                          <>
                            {option.status == "pending" &&
                            option.send_to_commitee_mem == null ? (
                              <Button className="sendApproBt showStatus">
                                {" "}
                                Need to Send For Approval
                              </Button>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                        {option.status == "approved" ? (
                          <span className="serviceProActive showStatus">
                            Active
                          </span>
                        ) : (
                          <></>
                        )}
                        {option.status == "rejected" ? (
                          <span className="serviceProRejct showStatus">
                            Rejected
                          </span>
                        ) : (
                          <></>
                        )}

                        <span className="serviceProVerific">
                          Verification Inprogress
                        </span>

                        {/* <span className="New showStatus">New Service Provider </span> */}
                      </div>
                      <div className="visitContProf">
                        <Zoom>
                          {option.profile_pic ? (
                            <img src={option.profile_pic} />
                          ) : (
                            <img src={defaultProfilePic} />
                          )}
                        </Zoom>
                      </div>
                      <div className="visitContLeft">
                        <h3
                          className="visitContHed"
                          onClick={() =>
                            navigate(
                              "/DetailsViewOfServicePro/" +
                                option.service_provider_id
                            )
                          }
                        >
                          {option.firstname} {option.lastname}
                          {option.status == "approved" ? (
                            <Tooltip title="Approved" placement="bottom" arrow>
                              <VerifiedIcon className="verifiTblSt" />
                            </Tooltip>
                          ) : (
                            <></>
                          )}
                          {option.status == "pending" ? (
                            <Tooltip
                              title="Approval In Process"
                              placement="bottom"
                              arrow
                            >
                              <UpdateIcon className="progressIco" />
                            </Tooltip>
                          ) : (
                            <></>
                          )}
                          {option.status == "rejected" ? (
                            <Tooltip title="Rejected" placement="bottom" arrow>
                              <GppBadIcon className="rejectIco" />
                            </Tooltip>
                          ) : (
                            <></>
                          )}
                        </h3>
                        <p className="visitContMob">{option.contactno}</p>
                        <p className="visitContTime">{option.address}</p>
                        <div className="listingStars">
                          <div className="ratingDiv">
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                            <StarBorderIcon />
                          </div>
                        </div>
                      </div>
                      <div className="visitBottCont">
                        <p>Service Type</p>
                        <b>{option.service_type}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Qualification</p>
                        <b>{option.qualification}</b>
                      </div>

                      {option.status == "rejected" ? (
                        <div className="visitBottCont">
                          <p>Reason Of Rejection</p>
                          <b style={{ color: "#F03939" }}>
                            {option.rejected_reason}
                          </b>
                        </div>
                      ) : (
                        <>
                          {option.status == "approved" ? (
                            <>
                              <div className="visitBottCont">
                                <p>Registered Since</p>
                                <b>
                                  {moment(option.registeged_date).format(
                                    "DD/MM/YYYY"
                                  )}
                                </b>
                              </div>
                              <div className="visitBottCont">
                                <p>Entry Pass</p>
                                <b>
                                  <Button
                                    className="emtyPassPreview"
                                    onClick={handleClickOpen2("body", option)}
                                  >
                                    Preview
                                  </Button>
                                </b>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                      <div className="resideNewCont">
                        <Tooltip
                          title="Send For Approval"
                          placement="top"
                          arrow
                        >
                          <ForwardToInboxIcon
                            className="sendForA"
                            onClick={handleClickOpen4(
                              "body",
                              option.service_provider_id,
                              option.send_to_commitee_mem,
                              option.approved_by_commitee_mem,
                              option.status
                            )}
                          />
                        </Tooltip>
                        <CreateIcon
                          className="editBt"
                          onClick={() => navigate("/EditServiceProvider")}
                        />
                        <DeleteIcon className="deleteBt" />
                        {/* <Switch {...label} size="small" /> */}
                      </div>
                    </div>
                    <div className="wingsDetails">
                      {option.status=='approved'?
                      <>
                      {option.resident?
                      <>
                      {option.resident.map((option1)=>(
                      <>
                      {option1.apartments?
                      <>
                      {option1.apartments.map((apt)=>(
                        <>
                        {(option1.user_type=='Resident User' && apt.is_current_stay == true)||(option1.user_type=='tenent')?
                        <div className="NewTailCountOut">
                        <Tooltip
                          title={apt.uniq_apt_name}
                          placement="top"
                          arrow
                        >
                          <div>
                            <div className="buildingNameNcount">
                              <p>{apt.uniq_apt_name.split(
                                                      "/"
                                                    )[1]}</p>
                                                   
                            </div>
                            <h1>{apt.uniq_apt_name.split(
                                                      "/"
                                                    )[2]}</h1>
                          </div>
                        </Tooltip>
                      </div>:
                      <></>}</>

                      ))}
                      </>:<></>}</>
                     
                      
                      ))}</>
                      :<></>}</>:<></>}

                     
                    </div>
                  </div>
                ))}
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Pagination
                      count={Math.ceil(totalItems / itemsPerPage)}
                      page={currentPage}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded"
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* <div className="modalMain">
        <Dialog
          open={open2}
          onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Entry Pass Preview</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="entryPassMain">
                      <div className="entryPassInner">
                        <div className="entryPassTop">
                          <h4>Park Side Apartment</h4>
                          <Button>Security Guard</Button>
                          <div className="entryPassProMain">
                            <div className="entryPassPro">
                              <Zoom>
                                <img src="https://i.pinimg.com/474x/7f/9d/93/7f9d93408e934aced0f2409656bca021.jpg" />
                              </Zoom>
                            </div>
                            <p>Devon Lane</p>
                            <span>(808) 555-0111</span>
                          </div>
                        </div>
                        <div className="entryPassBott">
                          <div className="emtyPssBarOut">
                            <Zoom>
                              <img src="https://www.freepnglogos.com/uploads/qr-code-png/qr-code-file-bangla-mobile-code-0.png" />
                            </Zoom>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={addCommitee}>
                        Download
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>Successfully Downloaded</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div> */}

      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Entry Pass Preview</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="entryPassMain entryPassMain2">
                      <div className="entryPassInner">
                        <h4 className="entryParkHeading">
                          {localStorage.getItem("societyName")}
                        </h4>
                        <div className="entryPassPro">
                          <Zoom>
                            {selectedProfilePic ? (
                              <img src={selectedProfilePic} />
                            ) : (
                              <img src={defaultProfilePic} />
                            )}
                          </Zoom>
                        </div>
                        <div>
                          <Button className="serviceNameBt">
                            {selectedServiceType}
                          </Button>
                        </div>
                        <div className="entryPassNameNum">
                          <p>{selectedName}</p>
                          <span>{selectedContactNo}</span>
                        </div>
                        <div className="entryPassBott">
                          <div className="emtyPssBarOut">
                            <Zoom>
                              <div
                                style={{
                                  height: "auto",
                                  margin: "0 auto",
                                  maxWidth: 64,
                                  width: "100%",
                                }}
                              >
                                <QRCode
                                  size={256}
                                  style={{
                                    height: "auto",
                                    maxWidth: "100%",
                                    width: "100%",
                                  }}
                                  value={JSON.stringify({
                                    id: providerId,
                                    contact: selectedContactNo,
                                    name: selectedName,
                                  })}
                                  viewBox={`0 0 256 256`}
                                />
                              </div>
                            </Zoom>
                          </div>
                          <p>Powered by Resipro</p>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={addCommitee}>
                        Print Entry Pass
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>Successfully Downloaded</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="modalMain">
        <Dialog
          open={open4}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Service Provider Approval</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose4} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div>
                <div className="servProvdrList">
                  <div className="serListOut">
                    <Tooltip title="Verfied" placement="top" arrow>
                      <IconButton aria-label="Example">
                        <VerifiedIcon className="verifiTblSt" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="In Progress" placement="top" arrow>
                      <IconButton aria-label="Example">
                        <UpdateIcon className="progressIco" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Rejected" placement="top" arrow>
                      <IconButton aria-label="Example">
                        <GppBadIcon className="rejectIco" />
                      </IconButton>
                    </Tooltip>
                    <Checkbox
                      {...label}
                      checked={isApprovedByAdmin}
                      onChange={(e) => setIsApprovedByAdmin(e.target.checked)}
                    />
                    <div className="visitCont1 ">
                      <div className="visitContProf">
                        <Zoom>
                          {localStorage.getItem("profilePic") ? (
                            <img src={localStorage.getItem("profilePic")} />
                          ) : (
                            <img src={defaultProfilePic} />
                          )}
                        </Zoom>
                      </div>
                      <div className="visitContLeft">
                        <h3 className="visitContHed">
                          {localStorage.getItem("userName")}
                        </h3>
                        {/* <p className="visitContMob">
                      localStorage.getItem(userName)
                      </p> */}
                      </div>
                      <div className="">Admin</div>
                    </div>
                  </div>

                  {commiteeMemlist.map((commiteeOption) => (
                    <div className="serListOut">
                      {selectedCommitteMem.length > 0 ? (
                        <>
                          {selectedCommitteMem.includes(
                            commiteeOption.resident_id
                          ) ? (
                            <Checkbox
                              {...label}
                              checked
                              onChange={(e) =>
                                handleChangeCheckbox(
                                  e,
                                  commiteeOption.resident_id
                                )
                              }
                            />
                          ) : (
                            <Checkbox
                              {...label}
                              onChange={(e) =>
                                handleChangeCheckbox(
                                  e,
                                  commiteeOption.resident_id
                                )
                              }
                            />
                          )}
                        </>
                      ) : (
                        <Checkbox
                          {...label}
                          onChange={(e) =>
                            handleChangeCheckbox(e, commiteeOption.resident_id)
                          }
                        />
                      )}
                      <div className="visitCont1 ">
                        <div className="visitContProf">
                          <Zoom>
                            {commiteeOption.profile_pic ? (
                              <img src={commiteeOption.profile_pic} />
                            ) : (
                              <img src={defaultProfilePic} />
                            )}
                          </Zoom>
                        </div>
                        <div className="visitContLeft">
                          <h3 className="visitContHed">
                            {commiteeOption.user_obj.first_name}{" "}
                            {commiteeOption.last_name}
                          </h3>
                          <p className="visitContMob">
                            {commiteeOption.user_obj.contact_no}
                          </p>
                        </div>
                        <div className="">
                          {commiteeOption.user_designation}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="modalMainBtMain">
                  {selectedStatus == "pending" ? (
                    <Button
                      className="modalMainBt"
                      onClick={sendToCommiteeMemApproval}
                    >
                      Sent for Approval
                    </Button>
                  ) : (
                    <></>
                  )}
                  {selectedStatus == "approved" ? (
                    <Button className="modalMainBt">
                      {/* {is_sent_for_approval} */}
                      Approved
                    </Button>
                  ) : (
                    <></>
                  )}
                  {selectedStatus == "rejected" ? (
                    <Button className="modalMainBt">Rejected</Button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default AllServiceProvidersNewList;
